import { defineStore } from "pinia";
import { AppSnackbarProps } from "@maropost-ui/liquidsky-ui";

export const useShellBridgeStore = defineStore("shell-bridge-store", {
    state: () => ({
        shell: {
            snackbarMessages: {} as AppSnackbarProps,
        }
    }),

    getters: {
        getSnackbarMessage: (state) => state.shell.snackbarMessages,
    },

    actions: {
        setSnackbarMessage(messages: AppSnackbarProps) {
            this.shell.snackbarMessages = messages;
        },
    },
})